import { MjmlButton, MjmlColumn, MjmlSection } from "@faire/mjml-react";
import { type FC, Fragment } from "react";
import { makePollUrl } from "../../make-poll-url";
import type { PollButtonProps } from "./types";

export const StandardPollButtons: FC<Pick<PollButtonProps, "options" | "align" | "account_id">> = ({
  account_id,
  options,
  align,
}) => {
  const columnWidth = 100 / options.length;

  return (
    <Fragment>
      <MjmlSection mjmlClass="section" padding="0px">
        {options.map((option, index) => {
          const isFirst = index === 0;
          const isLast = index === options.length - 1;

          return (
            <MjmlColumn key={option.id} width={`${columnWidth}%`} padding="0">
              <MjmlButton
                key={option.id}
                href={makePollUrl(account_id, option.id)}
                align={align}
                width="100%"
                backgroundColor="#ffffff"
                border="1px solid #D1D5DB"
                borderLeft={isFirst ? undefined : "1px solid #D1D5DB"}
                borderRight={isLast ? undefined : "1px solid #D1D5DB"}
                borderRadius={isFirst ? "4px 0 0 4px" : isLast ? "0 4px 4px 0" : "0"}
                textTransform="none"
                color="#121828"
                padding="12px 0"
              >
                {option.text}
              </MjmlButton>
            </MjmlColumn>
          );
        })}
      </MjmlSection>
    </Fragment>
  );
};
